import { render } from "./EditableInput.vue?vue&type=template&id=36a18b31"
import script from "./EditableInput.vue?vue&type=script&lang=js"
export * from "./EditableInput.vue?vue&type=script&lang=js"

import "./EditableInput.vue?vue&type=style&index=0&id=36a18b31&lang=css"

import exportComponent from "../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__